/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Menueditorlunchheading3Inputs */

const en_menueditorlunchheading3 = /** @type {(inputs: Menueditorlunchheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit the lunch menu`)
};

const de_menueditorlunchheading3 = /** @type {(inputs: Menueditorlunchheading3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mittagsmenü bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit the lunch menu" |
*
* @param {Menueditorlunchheading3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menueditorlunchheading3 = /** @type {((inputs?: Menueditorlunchheading3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menueditorlunchheading3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menueditorlunchheading3(inputs)
	return de_menueditorlunchheading3(inputs)
});
export { menueditorlunchheading3 as "menuEditorLunchHeading" }